/* eslint-disable @typescript-eslint/no-explicit-any */
import { useNavigate } from "react-router-dom";
import { Button, Result } from "antd";
import labels from "./errorLabels";
import "./error.scss";
import Cookies from "universal-cookie";

function ErrorHandler({ errorCase }: any) {
  const navigate = useNavigate();
  const cookies = new Cookies();
  const {
    ERROR_PAGE: { NOT_FOUND, NO_ACCESS, NO_AUTH, SERVER_ERROR, COMP_ERROR },
  } = labels;

  const logoutFn = () => {
    const allCookies = cookies?.getAll();
    Object?.keys(allCookies)?.map((i) => {
      cookies?.remove(i);
    });
    navigate("/");
  };

  const chooseErrorHandler = (error: any) => {
    switch (error) {
      case NOT_FOUND:
        return (
          <Result
            status="404"
            title="404"
            subTitle="Sorry, the page you visited does not exist."
            extra={
              <Button
                className="error-page-action-btn"
                type="primary"
                onClick={() => navigate(-1)}
              >
                Go Back
              </Button>
            }
          />
        );

      case NO_AUTH:
        return (
          <Result
            status="403"
            title="401"
            subTitle="Sorry, session key has expired, Please Login back to continue."
            extra={
              <Button
                className="error-page-action-btn"
                type="primary"
                onClick={logoutFn}
              >
                Login
              </Button>
            }
          />
        );

      case NO_ACCESS:
        return (
          <Result
            status="403"
            title="403"
            subTitle="Sorry, you don't have access to this page."
            extra={
              <Button
                className="error-page-action-btn"
                type="primary"
                onClick={logoutFn}
              >
                Back Home
              </Button>
            }
          />
        );

      case COMP_ERROR:
        return (
          <Result
            status="500"
            title="Something went wrong"
            subTitle="Sorry, there are some problems with your operation."
            extra={
              <>
                <Button
                  type="primary"
                  className="error-page-action-btn"
                  key="console"
                  onClick={() => window.location.reload()}
                >
                  Reload
                </Button>
                <Button
                  type="primary"
                  className="error-page-action-btn"
                  onClick={logoutFn}
                >
                  Back Home
                </Button>
              </>
            }
          />
        );

      case SERVER_ERROR:
        return (
          <Result
            status="500"
            title="500"
            subTitle="Sorry, the server is reporting an error."
            extra={
              <Button
                className="error-page-action-btn"
                type="primary"
                onClick={() => window.location.reload()}
              >
                Reload
              </Button>
            }
          />
        );
      default:
        break;
    }
    return (
      <Result
        status="500"
        title="Something went wrong"
        subTitle="Sorry, there are some problems with your operation."
        extra={
          <>
            <Button
              type="primary"
              className="error-page-action-btn"
              key="console"
              onClick={() => window.location.reload()}
            >
              Reload
            </Button>
            <Button
              type="primary"
              className="error-page-action-btn"
              onClick={logoutFn}
            >
              Back Home
            </Button>
          </>
        }
      />
    );
  };
  return <div className="error-page-main">{chooseErrorHandler(errorCase)}</div>;
}

export default ErrorHandler;
